/**
 * prefer this way to instance of because that one has limitations
 */
export function isError(e) {
  return (
    e &&
    e.stack &&
    e.message &&
    typeof e.stack === "string" &&
    typeof e.message === "string"
  );
}

/**
 * Use only on server side
 * @param {*} name
 * @returns
 */
export function ensureEnv(name) {
  if (process.client) {
    throw new Error("ensureEnv is only available on server side");
  }
  const value = process.env[name];
  if (!value) {
    console.error(`Missing env variable ${name}`);
    throw new Error(`Missing env variable ${name}`);
  }
  return value;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const SENSITIVE_QUERY_PARAMS = [
  "admin_token",
  "passwordRecoveryCode",
  "emailConfirmationCode",
  "password",
  "newPassword",
];

function safeDecode(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}

/**
 * Masks the values of security-sensitive query params (auth/impersonation
 * tokens, reset codes) so secrets never reach logs or Sentry breadcrumbs via
 * the request URL.
 */
export function redactSensitiveUrl(url) {
  if (typeof url !== "string") {
    return url;
  }
  const queryStart = url.indexOf("?");
  if (queryStart === -1) {
    return url;
  }
  const path = url.slice(0, queryStart);
  const redactedQuery = url
    .slice(queryStart + 1)
    .split("&")
    .map((pair) => {
      const key = pair.split("=")[0];
      const isSensitive = SENSITIVE_QUERY_PARAMS.some(
        (param) => param.toLowerCase() === safeDecode(key).toLowerCase()
      );
      return isSensitive ? `${key}=[REDACTED]` : pair;
    })
    .join("&");
  return `${path}?${redactedQuery}`;
}

/**
 * Returns a shallow copy of an object with the values of sensitive keys replaced
 * by "[REDACTED]", so secrets/PII never reach logs while the presence of the
 * field stays visible for debugging. Keys are matched case-insensitively.
 */
export function redactSensitiveFields(obj, sensitiveKeys) {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  const sensitive = new Set(sensitiveKeys.map((key) => key.toLowerCase()));
  const result = { ...obj };
  for (const key of Object.keys(result)) {
    if (sensitive.has(key.toLowerCase())) {
      result[key] = "[REDACTED]";
    }
  }
  return result;
}
